import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { SnackBar } from 'src/components/SnackBar';
import ProjectDetailsTable from './ProjectDetailsTable';
import './ProjectDetails.css';
import { getRolePermissions } from 'src/services/authService';
import { useNavigate } from 'react-router';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';

function ProjectDetails() {
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState([]);

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs?.filter((fil) => fil.name === 'Project');
      setPermissions(arr[0]?.permissions);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Project Details Management</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <ProjectDetailsTable permissions={permissions} />
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
}

export default ProjectDetails;
